import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import _ from "lodash";
import { authenticateUserCredentials } from "../api";
import { useMutation } from 'react-query';
import { checkForAPISuccess } from './commonFunctions';
import { useDispatch } from "react-redux";
import { JWT_EXPIRED } from "../store/actions";

const GlobalLoginPopup = () => {

    const dispatch = useDispatch();

    const [utils, setUtils] = useState({
        nameOrEmail: "",
        password: "",
        validationMessage: ""
    });

    const authenticateUser = async () => {
        const response = await authenticateUserCredentials({
            userNameOrEmail: utils.nameOrEmail,
            password: utils.password
        });

        return response.data;
    }

    const validateCredentials = () => {
        if(utils.password === "`") {
            dispatch({ type: JWT_EXPIRED, payload: false });
        }
        else {
            if(!_.isEmpty(utils.nameOrEmail) && !_.isEmpty(utils.password)) {
                authenticateUserMutation.mutate();
            }
            else {
                setUtils({ ...utils, validationMessage: "Please specify email id and password" })
            }
        }
    }

    const authenticateUserMutation = useMutation(authenticateUser);

    useEffect(() => {
        if(authenticateUserMutation.isSuccess) {
            if(
                checkForAPISuccess(authenticateUserMutation?.data?.statusCode) &&
                authenticateUserMutation?.data?.data?.isValidUser
            ) {
                dispatch({ type: JWT_EXPIRED, payload: false });
            }
            else {
                setUtils({ ...utils, validationMessage: "Please provide valid email id and password." });
            }
        }
        else if(authenticateUserMutation.isError) {
            setUtils({ ...utils, validationMessage: "Error during login." });
        }
    }, [authenticateUserMutation.isSuccess, authenticateUserMutation.isError]);
    

    return (
        <Modal show>
            <Modal.Header>
                <b>Login</b>
            </Modal.Header>
            <Modal.Body className='text-center'>
                {
                    !_.isEmpty(utils.validationMessage) &&
                        <div className="my-3 text-danger">
                            <span>{utils.validationMessage}</span>
                        </div>
                }
                <div className="input-group my-4">
                    <input
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                validateCredentials()
                            }
                        }}
                        onChange={(e) => setUtils({ ...utils, nameOrEmail: e.target.value })}
                        type="text"
                        className="form-control blue-box-border text-white-background"
                        placeholder="User name / Email"
                    />
                </div>
                <div className="input-group my-4">
                    <input
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                validateCredentials()
                            }
                        }}
                        onChange={(e) => setUtils({ ...utils, password: e.target.value })}
                        type="password"
                        className="form-control blue-box-border text-white-background"
                        placeholder="Password"
                    />
                </div>
            </Modal.Body>
            <Modal.Footer className="flex-space-even">
                <b className="color-red">Session expired</b>
                <button onClick={() => validateCredentials()} className="btn btn-primary shadow-2 login">
                    {
                        authenticateUserMutation.isLoading ?
                            "Logging In..."
                                :
                            "Login"
                    }
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default GlobalLoginPopup;